/* eslint-disable @typescript-eslint/naming-convention */
export interface FusionEntity {
	entity_name: string;
	entity_title: string;
}
